import { Grid } from "@material-ui/core";
import { prefixNoRM } from "App/Component/layout/Registrasi/utils";
import {
  InputReactDatepicker,
  Modal,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { instance3 } from "App/constants";
import { getToken } from "App/utils/cookies";
import {
  convertToValidPrice,
  defaultDateDisplay,
  defaultToastError,
  formatRupiah,
  getLocalName,
  today,
} from "App/utils/helpers";
import fileDownload from "js-file-download";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { KODE_PRINTER_SETTING, URL_SETTING } from "utils/all";

const RESET_STATE_KWITANSI = {
  tanggal: today(true),
  no_transaksi: "",
  no_rm: "",
  nama: "",
  penanggung: "",
  sudah_terima: "",
  untuk_pembayaran: "",
  nilai: "",
  terbilang: "",
};

function ModalKwitansi({ setShowModal, nama, noRM, nilai, no_transaksi }) {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [formData, setFormData] = useState({
    ...RESET_STATE_KWITANSI,
    no_rm: noRM,
    nama,
    nilai,
    no_transaksi,
  });
  const { setting } = useSelector((state) => state);
  const cetakButtonTagihan = setting.cetak_button_tagihan;
  const printerEnv = setting.printer_env;
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleClickCetak = (kop) => {
    return window.open(
      `http://localhost/${
        process.env.REACT_APP_PRINT_NAME
      }/public/api/print-kwitansi-penjualan?penjualan_id=${
        formData.no_transaksi
      }&tgl_penjualan=${defaultDateDisplay(
        formData.tanggal,
        false
      )}&rm_id=${prefixNoRM(formData.no_rm)}&nama=${
        formData.nama
      }&jml_bayar=${convertToValidPrice(
        formData.nilai
      )}&petugas=${getLocalName()}&penanggung=${
        formData.penanggung
      }&untuk_pembayaran=${formData.untuk_pembayaran}&sudah_terima=${
        formData.sudah_terima
      }&kota_rumah_sakit=${
        printerEnv.kota_rumah_sakit
      }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
        KODE_PRINTER_SETTING.printer_kwitansi_penjualan
      }&nama_rumah_sakit=${printerEnv.nama_rumah_sakit}&fax_rumah_sakit=${
        printerEnv.fax_rumah_sakit
      }&no_tlp_rumah_sakit=${
        printerEnv.no_tlp_rumah_sakit
      }&alamat_rumah_sakit=${printerEnv.alamat_rumah_sakit}&kop=${kop}`,
      "MsgWindow"
    );
  };

  const handleClickPdf = async () => {
    setLoadingPrint(true);
    const response = await getPdfKwitansiById(formData);
    if (response.state) {
      fileDownload(response.data, `Kwitansi ID ${formData.no_transaksi}.pdf`);
      setLoadingPrint(false);
    } else {
      defaultToastError(response.message);
      setLoadingPrint(false);
    }
  };

  return (
    <Modal title={`Kwitansi`} show={setShowModal}>
      <form>
        <Grid container spacing={1}>
          <Grid item sm={6}>
            <InputReactDatepicker
              selected={formData.tanggal}
              label="TANGGAL"
              dateFormat="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              showTimeSelect
              timeIntervals={5}
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal: e,
                })
              }
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="no_transaksi"
              label="NO TRANSAKSI"
              id="no_transaksi"
              value={formData.no_transaksi}
              onChange={handleChange("no_transaksi")}
              placeholder="No Transaksi"
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="no_rm"
              label="NO RM"
              id="no_rm"
              value={formData.no_rm}
              disabled={true}
              onChange={handleChange("no_rm")}
              placeholder="NO RM"
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="nama"
              label="NAMA"
              id="nama"
              value={formData.nama}
              onChange={handleChange("nama")}
              placeholder="NAMA"
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name="penanggung"
              label="PENANGGUNG"
              id="penanggung"
              value={formData.penanggung}
              onChange={handleChange("penanggung")}
              placeholder="Penanggung"
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name="sudah_terima"
              label="SUDAH DITERIMA"
              id="sudah_terima"
              value={formData.sudah_terima}
              onChange={handleChange("sudah_terima")}
              placeholder="Sudah Diterima"
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name="untuk_pembayaran"
              label="UNTUK PEMBAYARAN"
              id="untuk_pembayaran"
              value={formData.untuk_pembayaran}
              onChange={handleChange("untuk_pembayaran")}
              placeholder="Sudah Diterima"
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name="nilai"
              label="SEBESAR"
              id="nilai"
              value={formatRupiah(formData.nilai)}
              disabled
              // onChange={(e) => {
              //   let val = e.target.value;
              //   setFormData({
              //     ...formData,
              //     nilai: formatRupiah(val),
              //   });
              // }}
              placeholder="Sebesar"
            />
          </Grid>

          <Grid
            alignContent="center"
            container
            direction="row"
            justifyContent="flex-end"
            style={{
              gap: "1rem",
            }}
            alignItems="center"
          >
            {parseInt(cetakButtonTagihan.kwitansi_dengan_kop) === 1 && (
              <MasterButton
                className={"mt-1"}
                type="button"
                color={"warning"}
                name={"CETAK KOP"}
                onClick={() => handleClickCetak(1)}
                size="md"
              />
            )}
            <MasterButton
              className={"mt-1"}
              type="button"
              color={"warning"}
              name={"CETAK PRINTER LX"}
              onClick={() => handleClickCetak(0)}
              size="md"
            />
            <MasterButton
              className={"mt-1"}
              type="button"
              color={loadingPrint ? "secondary" : "warning"}
              name={loadingPrint ? "Loading..." : "CETAK PDF"}
              onClick={() => handleClickPdf()}
              size="md"
            />
          </Grid>
        </Grid>
      </form>
    </Modal>
  );
}

export default ModalKwitansi;

export const getPdfKwitansiById = async (formData) => {
  try {
    const api2 = await instance3.get(
      `/tagihan/export-kwitansi-pdf?id=${
        formData.no_transaksi
      }&date=${defaultDateDisplay(
        formData.tanggal,
        false
      )}&petugas=${getLocalName()}&penanggung=${
        formData.penanggung
      }&sudah_terima=${formData.sudah_terima}&untuk_pembayaran=${
        formData.untuk_pembayaran
      }&bayar_jual=${convertToValidPrice(formData.nilai)}&id_rm=${prefixNoRM(
        formData.no_rm
      )}&nama_rm=${formData.nama}`,
      {
        responseType: "blob",
      }
    );
    return {
      state: true,
      data: api2.data,
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
